export default "__VITE_ASSET__CLxDTHxt__"